import {
  EmployerAdminInvoiceTableRow,
  EmployerAdminInvoice,
  InvoiceType,
  EmployerPaymentStatus
} from 'Utils/types/invoice'
import { paymentInfoWithStars } from 'Utils/helpers/paymentTypes'

export const convertEmployerAdminInvoiceToTableRow = (
  invoice: EmployerAdminInvoice,
  employerId: number
): EmployerAdminInvoiceTableRow => {
  const isPaymentProcessing = invoice.employerPaymentStatus === EmployerPaymentStatus.Sent
  const previousPaymentFailed = invoice.employerPaymentStatus === EmployerPaymentStatus.Failed

  return {
    id: invoice.id,
    employerId: employerId,
    date: invoice.dateCreated,
    countryCode: invoice.countryCode,
    state: invoice.state,
    paymentMethod: paymentInfoWithStars(
      isPaymentProcessing ? invoice.processingPaymentInfo : invoice.payments?.[0]?.paymentInfo
    ),
    joonFees: invoice.joonFees,
    benefitTransferAmount: invoice.benefitTransfersTotal,
    benefitTransferFees: invoice.benefitTransferFees,
    payDate: invoice.payments?.[0]?.createdAt,
    type: invoice.alternativeReimbursement ? InvoiceType.Payroll : InvoiceType.JOON,
    stripeInvoiceId: invoice.stripeInvoiceId,
    previousPaymentFailed,
    invoice
  }
}

export const findLatestInvoiceDate = (invoices: EmployerAdminInvoice[]): Date | null => {
  if (invoices.length === 0) return null

  const dates = invoices
    .map((invoice) => invoice.dateCreated)
    .sort((a, b) => {
      return b.getTime() - a.getTime()
    })

  return dates[0]
}
